import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModuleContentSidebarService {
  private subjectSidebarStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get onChangedSidebarStatus() {
    return this.subjectSidebarStatus.asObservable();
  }

  public open(): void {
    this.subjectSidebarStatus.next(true);
  }

  public close(): void {
    this.subjectSidebarStatus.next(false);
  }

  public async toggle() {
    this.subjectSidebarStatus.next(!this.subjectSidebarStatus.value);
  }
}
